import { useFrame, useThree } from '@react-three/fiber';
import { useLayoutEffect } from 'react';
import { IMode, useDataStore } from '../zustand';
import { PresetAnimationController } from './r3f-components/animationControllers/presetAnimationController';
import { Jute } from '..';

export let presetAnimationController: PresetAnimationController;

const PresetAnimationControllerComponent = () => {
	const { scene: threeScene,  } = useThree();
	const componentsById = useDataStore(({ componentsById }) => componentsById);
	const rootId = useDataStore(({ rootId }) => rootId);

	useLayoutEffect(() => {
		// Add global animation preset manager once threejs scene created and component data available
		// This animation preset manager is used throughout Jute to control animation presets by scene and entity ids

		if (!threeScene || !!presetAnimationController || !componentsById || !rootId) return;

		presetAnimationController = new PresetAnimationController({
			componentsById, 
			scene: threeScene,
			//debug: true,
			adjustSpatialPositions: true,
			threeEntitySelectorPrefix: 'transformGroup-',
			mode: Jute.isIframe ? IMode.nonar : IMode.ar, 
			rootId	
		});
		
	}, [threeScene, componentsById, rootId])

	useFrame(() => {
		//console.log('frame')
		presetAnimationController?.tick()
	})

	return null;
};

export default PresetAnimationControllerComponent;
